import { trans } from "@mongez/localization";
import { productAtom } from "core/catalog";
import { Price } from "~/modules/our-cakes/components/Price";
import { price } from "~/modules/shared/utils";
import { productFinalPriceAtom, selectedCustomOptionsAtom } from "../atoms";
import { useValidateRequiredCustomOptions } from "../hooks";
import { CustomOptions } from "./custom-options";
import { ProductAddToCart } from "./ProductAddToCart";
import { ProductVariations } from "./ProductVariations";

export function ProductDetailsData() {
  const product = productAtom.use("product");

  const productPrice = product.salePrice || product?.price || 0;

  const finalPrice = productFinalPriceAtom.useValue();

  const selectedCustomOptions = selectedCustomOptionsAtom.useValue();

  const isValid = useValidateRequiredCustomOptions();

  return (
    <div className="flex w-full flex-col items-start gap-4">
      <div className="flex flex-col gap-2">
        {/* Stock Status */}
        <span className="font-avenir w-fit rounded-full border border-black bg-white/30 px-4 py-1 text-center text-sm font-extrabold text-[#fc637b] lg:text-base">
          {product.inStock ? trans("inStock") : trans("outOfStock")}
        </span>
        {/* Product Name */}
        <h1 className="text-2xl font-bold md:text-4xl">{product.name}</h1>
        {/* Product Short Description */}
        {product.shortDescription && (
          <p className="font-avenir text-lg font-medium text-[#0A0A0A]/60 sm:text-xl">
            {product.shortDescription}
          </p>
        )}
        {/* Product Price */}
        <Price
          originalPrice={product.price.original}
          salePrice={product.price.sale}
          classes={{
            salePrice: "text-3xl lg:text-4xl font-extrabold",
            price: !product.price.sale
              ? "text-2xl lg:text-4xl font-extrabold"
              : "",
          }}
        />
      </div>

      {/* Product Variations and Custom Options */}
      <div className="flex w-full flex-col gap-6">
        <div className="flex w-full flex-col gap-4">
          <ProductVariations />
          <span className="bg-border h-px w-full"></span>
          <CustomOptions />
        </div>
        {/* Product Final Price */}
        {finalPrice !== productPrice && finalPrice > 0 && (
          <div className="text-2xl font-semibold">
            {trans("finalPrice")}:{" "}
            <span className="text-primary-default">{price(finalPrice)}</span>
          </div>
        )}
        {/* Product Add to Cart */}
        <ProductAddToCart
          product={product}
          selectedCustomOptions={selectedCustomOptions.filter((option) =>
            Array.isArray(option.value)
              ? option.value.length > 0
              : option.value !== "",
          )}
          isValid={isValid}
        />
      </div>
    </div>
  );
}
